export default "__VITE_ASSET__BIReoyUq__"